import { z } from 'zod/v3';
import { AlgorithmJoinItemFormDataSchema } from './AlgorithmJoinItemFormDataSchema';

export const AlgorithmJoinFormDataSchema = z.object({
  id: z.number(),
  sequenceNumber: z.number(),
  algorithmSourceId: z.number(),
  joinTypeCode: z.enum(['FULL_OUTER', 'LEFT_OUTER', 'INNER']).nullable(),
  algorithmJoinItems: AlgorithmJoinItemFormDataSchema.array(),
});
